function e(e,{value:t,selectionStart:o,selectionEnd:i}){void 0!==t&&(e.value=t),void 0!==o&&void 0!==i&&e.setSelectionRange(o,i)}export{e as default};
